app.controller("ExamsManagerExclusionsController", [
    "$scope", "ExamsManagerService", "ConfirmModal", "$state", "$uibModal", "Subject", "toastr",
    function ($scope, ExamsManagerService, ConfirmModal, $state, $uibModal, Subject, toastr) {

        $scope.chosenSubject = null;

        $scope.fetch = function () {
            ExamsManagerService.fetchSubjectExclusions().then(function (data) {
                $scope.subjectExclusions = data;
                $scope.totalItems = data.length;
                console.log(data);
            });
        };

        $scope.fetch();

        $scope.add = function () {
            if (!$scope.chosenSubject || !$scope.chosenSubject._id)
                return;
            ExamsManagerService.addSubjectExclusion({subjectId: $scope.chosenSubject._id}).then(function () {
                $scope.fetch();
                $scope.chosenSubject = null;
                toastr.success('', 'ჩანაწერი წარმატებით დაემატა');
            });
            console.log($scope.chosenSubject);
        };


        $scope.getSubjects = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Subject.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.remove = function (subjectExclusion) {
            console.log(subjectExclusion);
            ConfirmModal.show({
                title: "საგნის წაშლა",
                message: "გსურთ საგნის სიიდან წაშლა?"
            }).result.then(function () {
                ExamsManagerService.removeSubjectExclusion({
                    subjectExclusionId: subjectExclusion._id
                }).then(function (result) {
                    toastr.success('', 'ჩანაწერი წარმატებით წაიშალა სიიდან');
                    $scope.fetch();
                });
            });
        };

    }
]);